/**
 * Tab identifiers for the Accounting V2 expense surfaces.
 *
 * Kept in its own module so AdvancedExpenseTabs.tsx exports components only,
 * which is what react-refresh needs to hot-reload that file correctly.
 */

export type AdvancedExpenseTab =
  | 'register'
  | 'overview'
  | 'categories'
  | 'approvals'
  | 'reimbursements'
  | 'cards'
  | 'refunds'
  | 'billable'
  | 'reports';

export const ADVANCED_EXPENSE_TABS: Array<{ id: AdvancedExpenseTab; label: string }> = [
  // The register is the read/write entry point into the V2 engine, so it leads.
  { id: 'register', label: 'Expense Register' },
  { id: 'overview', label: 'Overview' },
  { id: 'approvals', label: 'Approvals' },
  { id: 'reimbursements', label: 'Reimbursements' },
  { id: 'cards', label: 'Corporate Cards' },
  { id: 'refunds', label: 'Refunds' },
  { id: 'billable', label: 'Billable' },
  { id: 'categories', label: 'Categories' },
  { id: 'reports', label: 'Reports' },
];
